import script from "./max-request-config.vue?vue&type=script&setup=true&lang=js"
export * from "./max-request-config.vue?vue&type=script&setup=true&lang=js"

import "./max-request-config.vue?vue&type=style&index=0&id=748e1f2e&scoped=true&lang=scss"

import exportComponent from "D:\\vsts-agent\\_work\\42\\s\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-748e1f2e"]])

export default __exports__